var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../../../../babel-loader/lib/index.js??ruleSet[1].rules[2].use!./index.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../../../expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
___EXPOSE_LOADER_GLOBAL_THIS___["theme"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
